import React, { createRef } from "react";
import ReactDOM from "react-dom";
import { showModal } from "@tarojs/taro";
import DialogComponent, { DialogRef } from "../../DialogComponent";
import Button from "../../Button";
import { XHComponentCommonProps } from "../../../types";

export type ConfirmProps = {
  title?: string;
  header?: string;
  content: string;
  cancelText?: string;
  confirmText?: string;
} & {
  /** 取消按钮的文字颜色，必须是 16 进制格式的颜色字符串 */
  cancelColor?: string;
  /** 取消按钮的文字，最多 4 个字符 */
  cancelText?: string;
  /** 接口调用结束的回调函数（调用成功、失败都会执行） */
  complete?: (res: TaroGeneral.CallbackResult) => void;
  /** 确认按钮的文字颜色，必须是 16 进制格式的颜色字符串 */
  confirmColor?: string;
  /** 确认按钮的文字，最多 4 个字符 */
  confirmText?: string;
  /** 提示的内容 */
  content?: string;
  /** 接口调用失败的回调函数 */
  fail?: (res: TaroGeneral.CallbackResult) => void;
  /** 接口调用成功的回调函数 */
  success?: (result: ConfirmPropsResult) => void;
  /** 提示的标题 */
  title?: string;
} & XHComponentCommonProps;

export type ConfirmPropsResult = {
  /** 为 true 时，表示用户点击了取消（用于 Android 系统区分点击蒙层关闭还是点击取消按钮关闭） */
  cancel: boolean;
  /** 为 true 时，表示用户点击了确定按钮 */
  confirm: boolean;
  /** 调用结果 */
  errMsg: string;
};
const Comfirm = (props: ConfirmProps): Promise<ConfirmPropsResult> => {
  const {
    title = "",
    content,
    confirmText = "确定",
    cancelText = "取消",
    ...rest
  } = props;
  return new Promise(resolve => {
    if (process.env.TARO_ENV === "h5") {
      const div = document.createElement("div");

      const dialogRef = createRef<DialogRef>();
      const alertFooter = (
        <div className="xh-confirm-footer">
          <Button
            ghost
            type="default"
            shape="rectangle"
            className="xh-confirm-footer-button xh-confirm-footer-cancel-button"
            dataTrackId="xh-confirm-footer-cancel-button"
            onClick={() => {
              ReactDOM.unmountComponentAtNode(div);
              resolve({ errMsg: "ok", confirm: false, cancel: true });
            }}
          >
            {cancelText}
          </Button>
          <Button
            ghost
            type="primary"
            shape="rectangle"
            className="xh-confirm-footer-button xh-confirm-footer-confirm-button"
            dataTrackId="xh-confirm-footer-confirm-button"
            onClick={() => {
              ReactDOM.unmountComponentAtNode(div);
              resolve({ errMsg: "ok", confirm: true, cancel: false });
            }}
          >
            {confirmText}
          </Button>
        </div>
      );
      ReactDOM.render(
        <DialogComponent
          header={title}
          footer={alertFooter}
          content={content}
          visible
          ref={dialogRef}
          {...rest}
        />,
        div
      );
    } else {
      showModal({
        title,
        content,
        confirmColor: "#fe5e00",
        cancelText,
        cancelColor: "#666",
        confirmText,
        ...rest,
      }).then(resolve);
    }
  });
};

export default Comfirm;
